const STATUS_PRESENTATIONS = {
  pending: { label: 'Pendiente', classes: 'bg-amber-100 text-amber-800 border-amber-200' },
  pendiente: { label: 'Pendiente', classes: 'bg-amber-100 text-amber-800 border-amber-200' },
  en_recojo: { label: 'En recojo', classes: 'bg-sky-100 text-sky-800 border-sky-200' },
  encamino: { label: 'En camino', classes: 'bg-blue-100 text-blue-800 border-blue-200' },
  entregado: { label: 'Entregado', classes: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  delivered: { label: 'Entregado', classes: 'bg-emerald-100 text-emerald-800 border-emerald-200' },
  postergado: { label: 'Postergado', classes: 'bg-purple-100 text-purple-800 border-purple-200' },
  rechazado: { label: 'Rechazado', classes: 'bg-red-100 text-red-800 border-red-200' },
  cancelado: { label: 'Cancelado', classes: 'bg-slate-200 text-slate-700 border-slate-300' },
};

const LOCATION_PRESENTATIONS = {
  confirmed: { label: 'Ubicacion confirmada', shortLabel: 'Ubicacion lista', tone: 'emerald' },
  provisional: { label: 'Ubicacion referencial', shortLabel: 'Ubicacion referencial', tone: 'amber' },
  missing: { label: 'Falta ubicacion', shortLabel: 'Sin ubicacion', tone: 'red' },
};

export function deliveryStatusPresentation(status) {
  const normalized = String(status || '').trim().toLowerCase();
  return STATUS_PRESENTATIONS[normalized] || {
    label: status || 'Sin estado',
    classes: 'bg-slate-100 text-slate-700 border-slate-200',
  };
}

export function deliveryLocationPresentation(delivery = {}) {
  const hasFinalLocation = delivery.has_final_location
    ?? (delivery.latitude != null && delivery.longitude != null);
  const hasProvisionalLocation = (
    delivery.provisional_latitude != null && delivery.provisional_longitude != null
  );
  const hasAnyLocation = delivery.has_location ?? (hasFinalLocation || hasProvisionalLocation);
  const locationStatus = delivery.location_status
    || (hasFinalLocation ? 'confirmed' : hasAnyLocation ? 'provisional' : 'missing');
  return LOCATION_PRESENTATIONS[locationStatus] || LOCATION_PRESENTATIONS.missing;
}

export function formatDeliverySchedule(delivery = {}) {
  const rawDate = String(delivery.delivery_date || '').slice(0, 10);
  let formattedDate = '';
  if (rawDate) {
    const [year, month, day] = rawDate.split('-').map(Number);
    if (year && month && day) {
      formattedDate = new Intl.DateTimeFormat('es-PE', {
        day: 'numeric',
        month: 'short',
        timeZone: 'America/Lima',
      }).format(new Date(Date.UTC(year, month - 1, day, 12)));
    }
  }
  const slotLabel = delivery.slot_label || ({
    1: '1-4 pm',
    2: '2-5 pm',
    3: '3-6 pm',
    4: '4-7 pm',
    5: '5-8 pm',
    6: '6-9 pm',
  }[Number(delivery.slot)] || '');
  return [formattedDate, slotLabel].filter(Boolean).join(' · ');
}

export function formatDeliveryAmount(value) {
  if (value == null || value === '') return '';
  const amount = Number(value);
  return Number.isFinite(amount) ? `S/ ${amount.toFixed(2)}` : '';
}

export function deliverySearchText(delivery = {}) {
  if (delivery.found === false) return '';
  return [
    delivery.id,
    delivery.recipient_name,
    delivery.product,
    delivery.district,
    delivery.address,
    delivery.status,
    delivery.slot_label,
  ].filter(value => value != null).join(' ').toLowerCase();
}
